import React, { useEffect, useState } from "react";
import axios from "axios";
import { getCurrentShopId } from "./auth";
import "./StaffPage.css";

const API_URL = process.env.REACT_APP_API_URL || "https://api.deskpos.ie";

const getAuthConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("pos_token")}`,
  },
});

function StaffPage() {
  const [shopId, setShopId] = useState(null);
  const [staff, setStaff] = useState([]);
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    role: "cashier",
  });

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const currentShopId = getCurrentShopId();

    console.log("StaffPage current admin shop id:", currentShopId);

    setShopId(currentShopId);
  }, []);

  useEffect(() => {
    if (!shopId) return;

    loadStaff();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopId]);

  const loadStaff = async () => {
    if (!shopId) {
      setError("Shop is still loading. Please wait.");
      return;
    }

    try {
      setError("");

      const res = await axios.get(`${API_URL}/staff`, {
  params: { shop_id: shopId },
  ...getAuthConfig(),
});

      console.log("STAFF FOR SHOP:", shopId);
      console.log("STAFF DATA:", res.data);

      setStaff(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Load staff error:", err.response?.data || err.message);
      setError(err.response?.data?.error || "Failed to load staff");
    }
  };

  const createStaff = async (e) => {
    e.preventDefault();

    if (!shopId) {
      setError("Shop is still loading. Please wait.");
      return;
    }

    if (!form.name.trim() || !form.email.trim() || !form.password.trim()) {
      setError("Name, email and password are required");
      return;
    }

    try {
      setLoading(true);
      setMessage("");
      setError("");

     await axios.post(
  `${API_URL}/staff`,
  {
    shop_id: shopId,
    name: form.name.trim(),
    email: form.email.trim().toLowerCase(),
    password: form.password,
    role: form.role,
  },
  getAuthConfig()
);

      setForm({
        name: "",
        email: "",
        password: "",
        role: "cashier",
      });

      setMessage("Staff user created successfully");

      loadStaff();
    } catch (err) {
      console.error("Create staff error:", err.response?.data || err.message);
      setError(err.response?.data?.error || "Failed to create staff");
    } finally {
      setLoading(false);
    }
  };

  const toggleStaffStatus = async (staffUser) => {
    if (!shopId) {
      setError("Shop is still loading. Please wait.");
      return;
    }

    const isCurrentlyActive =
      staffUser.is_active ?? staffUser.active ?? staffUser.isActive ?? true;

    try {
      setMessage("");
      setError("");

     await axios.put(
  `${API_URL}/staff/${staffUser.id}/status`,
  {
    shop_id: shopId,
    is_active: !isCurrentlyActive,
  },
  getAuthConfig()
);

      setMessage(
        isCurrentlyActive
          ? "Staff user disabled successfully"
          : "Staff user enabled successfully"
      );

      loadStaff();
    } catch (err) {
      console.error(
        "Update staff status error:",
        err.response?.data || err.message
      );

      setError(err.response?.data?.error || "Failed to update staff status");
    }
  };

  return (
    <div className="staff-page">
      <div className="staff-header">
        <div>
          <h1>Staff</h1>
          <p>Create and manage cashier or manager accounts for this shop.</p>
        </div>

        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <span className="staff-shop-badge">Shop ID: {shopId || "-"}</span>

          <button onClick={loadStaff}>Refresh</button>
        </div>
      </div>

      {message && <div className="staff-message">{message}</div>}
      {error && <div className="staff-error">{error}</div>}

      <div className="staff-grid">
        <div className="staff-card">
          <h2>Create Staff User</h2>

          <form onSubmit={createStaff} className="staff-form">
            <label>
              Name
              <input
                type="text"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                placeholder="Example: John Cashier"
              />
            </label>

            <label>
              Email
              <input
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                placeholder="cashier@example.com"
              />
            </label>

            <label>
              Password
              <input
                type="password"
                value={form.password}
                onChange={(e) =>
                  setForm({ ...form, password: e.target.value })
                }
                placeholder="Password"
              />
            </label>

            <label>
              Role
              <select
                value={form.role}
                onChange={(e) => setForm({ ...form, role: e.target.value })}
              >
                <option value="cashier">Cashier</option>
                <option value="manager">Manager</option>
              </select>
            </label>

            <button type="submit" disabled={loading}>
              {loading ? "Creating..." : "Create Staff"}
            </button>
          </form>
        </div>

        <div className="staff-card staff-list-card">
          <h2>Staff List</h2>

          <div className="staff-table-wrap">
            <table className="staff-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Role</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {staff.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="no-staff">
                      No staff users found.
                    </td>
                  </tr>
                ) : (
                  staff.map((user) => {
                    const isActive =
                      user.is_active ?? user.active ?? user.isActive ?? true;

                    return (
                      <tr key={user.id}>
                        <td>#{user.id}</td>
                        <td>{user.name}</td>
                        <td>{user.email}</td>
                        <td>{user.role}</td>

                        <td>
                          <span
                            className={
                              isActive
                                ? "staff-status active"
                                : "staff-status inactive"
                            }
                          >
                            {isActive ? "Active" : "Inactive"}
                          </span>
                        </td>

                        <td>
                          {user.role === "shop_admin" ? (
                            <span className="staff-admin-lock">Protected</span>
                          ) : (
                            <button
                              className={
                                isActive
                                  ? "staff-disable-btn"
                                  : "staff-enable-btn"
                              }
                              onClick={() => toggleStaffStatus(user)}
                            >
                              {isActive ? "Disable" : "Enable"}
                            </button>
                          )}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StaffPage;